import { LinearProgress, List, ListItem, Typography } from '@mui/material';
import { observer } from 'mobx-react';
import React from 'react';
import Modal from '@/misc/Modal';
import ImportacaoLoteStore from '@/store/ImportacaoLoteStore';

class ProgressoImportacaoLote extends React.Component {

    fecharModal = () => {
        ImportacaoLoteStore.fecharProgresso();
    };

    render() {
        const store = ImportacaoLoteStore;

        return (
            <Modal
                aberto={store.abertoProgresso}
                fecharModal={this.fecharModal}
                titulo="Importação em Lote - Progresso"
                funcaoAcaoSecundaria={this.fecharModal}
                labelAcaoSecundaria="Fechar"
                acaoSecundariaDisabled={store.processando}
                maxWidth="md"
                fullWidth
            >
                <Typography variant="body1" gutterBottom>
                    {store.faseAtual}
                </Typography>
                <LinearProgress
                    variant="determinate"
                    value={store.progresso}
                    sx={{ height: 8, borderRadius: 4, marginBottom: '16px' }}
                />
                <Typography variant="body2" color="textSecondary" gutterBottom>
                    {store.processando
                        ? `Processados: ${store.processados} de ${store.totalProcessos}`
                        : store.concluido
                            ? 'Processamento concluído.'
                            : ''
                    }
                </Typography>
                {store.mensagens.length > 0 && (
                    <List
                        sx={{
                            maxHeight: '300px',
                            overflowY: 'auto',
                            border: '1px solid #e0e0e0',
                            borderRadius: '4px',
                            marginTop: '12px',
                        }}
                    >
                        {store.mensagens.map((msg, index) => (
                            <ListItem
                                key={`msg-progresso-lote-${index}`}
                                sx={{
                                    fontSize: '0.875rem',
                                    fontWeight: index === 0 ? 600 : 400,
                                    color: index === 0 ? 'text.primary' : 'error.main',
                                }}
                            >
                                {msg}
                            </ListItem>
                        ))}
                    </List>
                )}
            </Modal>
        );
    }
}

export default observer(ProgressoImportacaoLote);
